// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button {
  display: block;
  position: relative;
  width: 56px;
  height: 56px;
  margin: 0;
  overflow: hidden;
  outline: none;
  background-color: transparent;
  cursor: pointer;
  border: 0;
}

.button:before,
.button:after {
  content: "";
  position: absolute;
  border-radius: 50%;
  inset: 7px;
}

.button:before {
  border: 4px solid #f0eeef;
  transition: opacity 0.4s cubic-bezier(0.77, 0, 0.175, 1) 80ms,
    transform 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955) 80ms;
}

.button:after {
  border: 4px solid #be19be;
  transform: scale(1.3);
  transition: opacity 0.4s cubic-bezier(0.165, 0.84, 0.44, 1),
    transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  opacity: 0;
}

.button:hover:before,
.button:focus:before {
  opacity: 0;
  transform: scale(0.7);
  transition: opacity 0.4s cubic-bezier(0.165, 0.84, 0.44, 1),
    transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.button:hover:after,
.button:focus:after {
  opacity: 1;
  transform: scale(1);
  transition: opacity 0.4s cubic-bezier(0.77, 0, 0.175, 1) 80ms,
    transform 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955) 80ms;
}

.button-box {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
}

.button-elem {
  display: block;
  width: 20px;
  height: 20px;
  margin: 16px 18px 0 22px;
  transform: rotate(90deg);
  fill: #ffffff;
}

.button:hover .button-box,
.button:focus .button-box {
  transition: 0.4s;
  transform: translateY(50px);
}

.container {
  margin-top: -49px;
}

span:nth-child(2) {
  margin-top: 30px;
}
`, "",{"version":3,"sources":["webpack://./src/asset/css/Arrow.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB;+DAC6D;AAC/D;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB;uDACqD;EACrD,UAAU;AACZ;;AAEA;;EAEE,UAAU;EACV,qBAAqB;EACrB;uDACqD;AACvD;;AAEA;;EAEE,UAAU;EACV,mBAAmB;EACnB;+DAC6D;AAC/D;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,wBAAwB;EACxB,aAAa;AACf;;AAEA;;EAEE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".button {\n  display: block;\n  position: relative;\n  width: 56px;\n  height: 56px;\n  margin: 0;\n  overflow: hidden;\n  outline: none;\n  background-color: transparent;\n  cursor: pointer;\n  border: 0;\n}\n\n.button:before,\n.button:after {\n  content: \"\";\n  position: absolute;\n  border-radius: 50%;\n  inset: 7px;\n}\n\n.button:before {\n  border: 4px solid #f0eeef;\n  transition: opacity 0.4s cubic-bezier(0.77, 0, 0.175, 1) 80ms,\n    transform 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955) 80ms;\n}\n\n.button:after {\n  border: 4px solid #be19be;\n  transform: scale(1.3);\n  transition: opacity 0.4s cubic-bezier(0.165, 0.84, 0.44, 1),\n    transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  opacity: 0;\n}\n\n.button:hover:before,\n.button:focus:before {\n  opacity: 0;\n  transform: scale(0.7);\n  transition: opacity 0.4s cubic-bezier(0.165, 0.84, 0.44, 1),\n    transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n.button:hover:after,\n.button:focus:after {\n  opacity: 1;\n  transform: scale(1);\n  transition: opacity 0.4s cubic-bezier(0.77, 0, 0.175, 1) 80ms,\n    transform 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955) 80ms;\n}\n\n.button-box {\n  display: flex;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.button-elem {\n  display: block;\n  width: 20px;\n  height: 20px;\n  margin: 16px 18px 0 22px;\n  transform: rotate(90deg);\n  fill: #ffffff;\n}\n\n.button:hover .button-box,\n.button:focus .button-box {\n  transition: 0.4s;\n  transform: translateY(50px);\n}\n\n.container {\n  margin-top: -49px;\n}\n\nspan:nth-child(2) {\n  margin-top: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
